import { importImages } from '~/Utils';

export default {
  image: importImages(require.context('../Assets/Images', false, /\.(png|jpe?g|svg)$/)),
  imageCampaign: importImages(require.context('../Assets/Images/Campaign', false, /\.(png|jpe?g|svg)$/)),
};
